import React from 'react'
import styled from 'styled-components'
import { bool, number, oneOfType, object, string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { ETAPA_BRINDES, ETAPA_ENTREGA, ETAPA_PLANO, TITULO_RESUMO_TELA_CONCLUSAO } from '../constantsFluxosPagamento'
import { PLANO_ANUAL } from '../../../constants'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { formatValor } from '../../../utils/formatter/formatter'
import ListaResumoEndereco from '../components/ListaResumoEndereco'

const ResumoAssinaturaWrapper = styled.div`
  h3 {
    margin-bottom: 12px;
  }
`

const ListaResumoAssinatura = styled.ul`
  &:first-of-type {
    margin-bottom: 10px;
  }

  li {
    ${StyleGuide.tipografia.textoDefault}
    line-height: 1.56;

    b {
      ${StyleGuide.boldFonte}
    }

    small {
      ${StyleGuide.tipografia.textoPequeno}
    }

    p {
      font-size: 16px;
    }
  }
`

const NomeBrinde = styled.span`
  color: ${( { cor } ) => cor};
  ${StyleGuide.boldFonte}
`

const ResumoAssinaturaConclusao = ( {
  dadosDescontoCombo,
  hasDadosEntrega,
  hasDadosPlano,
  modalidadeSelecionadaConclusao,
  valorPlanoConclusao,
  showMessageRenovacaoAutomatica,
  precoFreteEntrega
} ) => {
  const { dadosEtapas, temaFluxo } = useFluxosPagamento()

  const hasBrindesConclusao =
    dadosEtapas &&
    Object.keys( dadosEtapas ).includes( ETAPA_BRINDES ) &&
    !isEmptyObject( dadosEtapas[ ETAPA_BRINDES ] )
  const tipoPlano = dadosEtapas[ ETAPA_PLANO ]?.tipo

  return (
    <ResumoAssinaturaWrapper>
      <h3>{TITULO_RESUMO_TELA_CONCLUSAO}</h3>

      <ListaResumoAssinatura>
        <li>{`TAG ${modalidadeSelecionadaConclusao.visualizacao}`}</li>

        {hasDadosPlano ?
          <li>
            {`Plano: ${tipoPlano} ${valorPlanoConclusao && formatValor( { 'valor': valorPlanoConclusao } )}`}

            <small>/mês</small>
          </li> : null}

        {showMessageRenovacaoAutomatica ?
          <li>
            Assinatura com renovação automática
          </li> : null}

        {dadosDescontoCombo && Boolean( dadosDescontoCombo.desconto ) ?
          <li>
            {`Desconto duas assinaturas*: ${formatValor( {
              'valor': dadosDescontoCombo.desconto
            } )}`}
          </li> : null}

        {hasDadosEntrega ? <li>{`Taxa de entrega: ${formatValor( { 'valor': precoFreteEntrega } )}`}</li> : null}

        {hasBrindesConclusao && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao ?
          <li>
            {'Brinde: '}

            <NomeBrinde cor={ temaFluxo }>
              {`${dadosEtapas[ ETAPA_BRINDES ].descricao}`}
            </NomeBrinde>
          </li> : null}
      </ListaResumoAssinatura>

      {!isEmptyObject( dadosEtapas[ ETAPA_ENTREGA ] ) && (
        <div>
          <ListaResumoAssinatura>
            <ListaResumoEndereco dadosEndereco={ dadosEtapas[ ETAPA_ENTREGA ] } />
          </ListaResumoAssinatura>
        </div>
      )}

      {dadosDescontoCombo.texto ? <p>{`*${dadosDescontoCombo.texto}`}</p> : null}

      {dadosEtapas[ ETAPA_ENTREGA ].hasEnvioUnico ?
        <p>
          **Você ganhou 30% de desconto no frete por ter duas assinaturas anuais
        </p> : null}
    </ResumoAssinaturaWrapper>
  )
}

ResumoAssinaturaConclusao.propTypes = {
  'dadosDescontoCombo': oneOfType( [ object, bool ] ).isRequired,
  'dadosGlobaisAssociado': object.isRequired,
  'hasDadosEntrega': bool.isRequired,
  'hasDadosPlano': bool.isRequired,
  'modalidadeSelecionadaConclusao': object.isRequired,
  'precoFreteEntrega': number.isRequired,
  'showMessageRenovacaoAutomatica': bool.isRequired,
  'tipoFluxo': string.isRequired,
  'valorPlanoConclusao': oneOfType( [ string, number ] ).isRequired,
}

export default ResumoAssinaturaConclusao
